const processResponse = (response, commit, callingFunction) => {
  if (response.status !== 200) {
    setTimeout(() => {
      commit(
        'app/showToast',
        {
          color: 'error',
          message: callingFunction + ': ' + response.statusText,
          timeout: 5000
        },
        { root: true }
      );

      return false;
    });
  } else if (!response.data) {
    setTimeout(() => {
      commit(
        'app/showToast',
        {
          color: 'error',
          message: 'No data found in ' + callingFunction,
          timeout: 5000
        },
        { root: true }
      );
    });

    return false;
  } else {
    return true;
  }
};

export default {
  processResponse
};
